import { render, staticRenderFns } from "./ViberCampaignEdit.vue?vue&type=template&id=a5d6101a&scoped=true&"
import script from "./ViberCampaignEdit.vue?vue&type=script&lang=js&"
export * from "./ViberCampaignEdit.vue?vue&type=script&lang=js&"
import style0 from "./ViberCampaignEdit.vue?vue&type=style&index=0&id=a5d6101a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5d6101a",
  null
  
)

export default component.exports